<div class="page-layout blank fullwidth p-12" style="height: 1px; overflow-y:scroll; top: 1px;" >
<div   class="wc-container-unique-main" *ngIf="showCertificateUI" >
    <div id="certificateDiv" class="wc-container-unique" >
    <div class="wc-header-unique">
        <!-- <div class="wc-badge-unique">AUTOVERSE</div> -->
        <img src="../../../../assets/icons/autoverse-logo.jfif">
        <div class="wc-cert-info-unique">
        <span>Certificate No.</span>
        <strong>{{certificateNumber}}</strong>
        </div>
    </div>

    <h1 class="wc-title-unique">WARRANTY CERTIFICATE</h1>
    <div class="background-color-div">
        <p class="wc-subtitle-unique">Issued through Autoverse in partnership with your trusted garage</p>

        <div class="wc-grid-unique">
            <div class="wc-card-unique">
                <!-- <i class="material-icons">home_repair_service</i> -->
                 <div class="card-icon-and-class-name">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.394 2.08003C10.2695 2.02667 10.1355 1.99915 10 1.99915C9.86455 1.99915 9.73051 2.02667 9.60601 2.08003L2.60601 5.08003C2.42562 5.15688 2.2718 5.28506 2.16368 5.44864C2.05557 5.61221 1.99792 5.80396 1.99792 6.00004C1.99792 6.19611 2.05557 6.38786 2.16368 6.55143C2.2718 6.71501 2.42562 6.84319 2.60601 6.92004L5.25001 8.05103C5.34815 7.94003 5.46975 7.85224 5.60601 7.79403L9.60601 6.08004C9.72682 6.02829 9.85665 6.00086 9.98807 5.99929C10.1195 5.99772 10.2499 6.02205 10.3719 6.0709C10.494 6.11974 10.6052 6.19214 10.6992 6.28396C10.7932 6.37578 10.8683 6.48522 10.92 6.60604C10.9717 6.72685 10.9992 6.85668 11.0008 6.9881C11.0023 7.11952 10.978 7.24996 10.9291 7.37197C10.8803 7.49399 10.8079 7.60519 10.7161 7.69923C10.6243 7.79326 10.5148 7.86829 10.394 7.92004L7.66701 9.08804L9.60701 9.91903C9.73137 9.97226 9.86523 9.99971 10.0005 9.99971C10.1358 9.99971 10.2696 9.97226 10.394 9.91903L17.394 6.91903C17.5744 6.84219 17.7282 6.71401 17.8363 6.55043C17.9444 6.38686 18.0021 6.19511 18.0021 5.99904C18.0021 5.80296 17.9444 5.61121 17.8363 5.44764C17.7282 5.28406 17.5744 5.15588 17.394 5.07904L10.394 2.08003ZM3.31001 9.39704L5.00001 10.12V14.222C4.65376 14.1433 4.30314 14.0852 3.95001 14.048C3.72215 14.0241 3.50943 13.9226 3.34742 13.7606C3.18542 13.5986 3.08395 13.3859 3.06001 13.158C2.9285 11.8989 3.01305 10.6266 3.31001 9.39604V9.39704ZM9.30001 16.573C8.62402 15.9098 7.84786 15.357 7.00001 14.935V10.978L8.81801 11.758C9.1915 11.9181 9.59364 12.0007 10 12.0007C10.4064 12.0007 10.8085 11.9181 11.182 11.758L16.69 9.39704C16.9887 10.6274 17.0733 11.9 16.94 13.159C16.9161 13.3869 16.8146 13.5996 16.6526 13.7616C16.4906 13.9236 16.2779 14.0251 16.05 14.049C14.0325 14.2611 12.1465 15.1508 10.7 16.573C10.5131 16.7563 10.2618 16.8589 10 16.8589C9.73825 16.8589 9.48694 16.7563 9.30001 16.573ZM6.00001 18C6.26522 18 6.51958 17.8947 6.70711 17.7071C6.89465 17.5196 7.00001 17.2653 7.00001 17V14.935C6.364 14.6191 5.6926 14.379 5.00001 14.222V17C5.00001 17.2653 5.10536 17.5196 5.2929 17.7071C5.48044 17.8947 5.73479 18 6.00001 18Z" fill="#D5A230"/>
                    </svg>
                    <span class="card-label">Garage Name</span>
                </div>
                <div class="card-text">
                <span class="card-value">{{ garageName }}</span>
                </div>
            </div>

            <div class="wc-card-unique">
                <!-- <i class="material-icons">person</i> -->
                <div class="card-icon-and-class-name">
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 6C7.79565 6 8.55871 5.68393 9.12132 5.12132C9.68393 4.55871 10 3.79565 10 3C10 2.20435 9.68393 1.44129 9.12132 0.87868C8.55871 0.316071 7.79565 0 7 0C6.20435 0 5.44129 0.316071 4.87868 0.87868C4.31607 1.44129 4 2.20435 4 3C4 3.79565 4.31607 4.55871 4.87868 5.12132C5.44129 5.68393 6.20435 6 7 6ZM0 15C-1.36979e-08 14.0807 0.18106 13.1705 0.532843 12.3212C0.884626 11.4719 1.40024 10.7003 2.05025 10.0503C2.70026 9.40024 3.47194 8.88463 4.32122 8.53284C5.1705 8.18106 6.08075 8 7 8C7.91925 8 8.8295 8.18106 9.67878 8.53284C10.5281 8.88463 11.2997 9.40024 11.9497 10.0503C12.5998 10.7003 13.1154 11.4719 13.4672 12.3212C13.8189 13.1705 14 14.0807 14 15H0Z" fill="#D5A230"/>
                    </svg>
                    <span class="card-label">Customer Name</span>
                </div>
                <div class="card-text">
                <span class="card-value">{{ customerName | titlecase }}</span>
                </div>
            </div>

            <div class="wc-card-unique">
                <!-- <i class="material-icons">event</i> -->
                <div class="card-icon-and-class-name">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C5.73478 2 5.48043 2.10536 5.29289 2.29289C5.10536 2.48043 5 2.73478 5 3V4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V16C2 16.5304 2.21071 17.0391 2.58579 17.4142C2.96086 17.7893 3.46957 18 4 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V6C18 5.46957 17.7893 4.96086 17.4142 4.58579C17.0391 4.21071 16.5304 4 16 4H15V3C15 2.73478 14.8946 2.48043 14.7071 2.29289C14.5196 2.10536 14.2652 2 14 2C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V4H7V3C7 2.73478 6.89464 2.48043 6.70711 2.29289C6.51957 2.10536 6.26522 2 6 2ZM6 7C5.73478 7 5.48043 7.10536 5.29289 7.29289C5.10536 7.48043 5 7.73478 5 8C5 8.26522 5.10536 8.51957 5.29289 8.70711C5.48043 8.89464 5.73478 9 6 9H14C14.2652 9 14.5196 8.89464 14.7071 8.70711C14.8946 8.51957 15 8.26522 15 8C15 7.73478 14.8946 7.48043 14.7071 7.29289C14.5196 7.10536 14.2652 7 14 7H6Z" fill="#D5A230"/>
                    </svg>
                    <span class="card-label">Date of Purchase</span>
                </div>
                <div class="card-text">
                <!-- <span class="card-value">{{ purchaseDate | date: 'MMM d, yyyy' }}</span> -->
                <span class="card-value">{{ purchaseDate | date:'dd MMM yyyy' | uppercase }}</span>

                </div>
            </div>

            <div class="wc-card-unique">
                <!-- <i class="material-icons">event</i> -->
                <div class="card-icon-and-class-name">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM11 6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6V10C9.00006 10.2652 9.10545 10.5195 9.293 10.707L12.121 13.536C12.2139 13.6289 12.3242 13.7026 12.4456 13.7529C12.567 13.8032 12.6971 13.8291 12.8285 13.8291C12.9599 13.8291 13.09 13.8032 13.2114 13.7529C13.3328 13.7026 13.4431 13.6289 13.536 13.536C13.6289 13.4431 13.7026 13.3328 13.7529 13.2114C13.8032 13.09 13.8291 12.9599 13.8291 12.8285C13.8291 12.6971 13.8032 12.567 13.7529 12.4456C13.7026 12.3242 13.6289 12.2139 13.536 12.121L11 9.586V6Z" fill="#D5A230"/>
                    </svg>
                    <span class="card-label">Warranty Period</span>
                </div>
                <div class="card-text">
                <!-- <span class="card-value">{{ validTill | date:'dd MMM yyyy' | uppercase }}</span> -->
                <span class="card-value">As per manufacturer’s policy</span>
                </div>
            </div>

            <div class="wc-card-unique">
                <!-- <i class="material-icons">speed</i> -->
                <div class="card-icon-and-class-name">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 16.5C8 16.8978 7.84196 17.2794 7.56066 17.5607C7.27936 17.842 6.89782 18 6.5 18C6.10218 18 5.72064 17.842 5.43934 17.5607C5.15804 17.2794 5 16.8978 5 16.5C5 16.1022 5.15804 15.7206 5.43934 15.4393C5.72064 15.158 6.10218 15 6.5 15C6.89782 15 7.27936 15.158 7.56066 15.4393C7.84196 15.7206 8 16.1022 8 16.5ZM15 16.5C15 16.8978 14.842 17.2794 14.5607 17.5607C14.2794 17.842 13.8978 18 13.5 18C13.1022 18 12.7206 17.842 12.4393 17.5607C12.158 17.2794 12 16.8978 12 16.5C12 16.1022 12.158 15.7206 12.4393 15.4393C12.7206 15.158 13.1022 15 13.5 15C13.8978 15 14.2794 15.158 14.5607 15.4393C14.842 15.7206 15 16.1022 15 16.5Z" fill="#D5A230"/>
                        <path d="M3 4C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5V15C2 15.2652 2.10536 15.5196 2.29289 15.7071C2.48043 15.8946 2.73478 16 3 16H4.05C4.16476 15.4349 4.47136 14.9268 4.91787 14.5618C5.36438 14.1969 5.92332 13.9975 6.5 13.9975C7.07668 13.9975 7.63562 14.1969 8.08213 14.5618C8.52864 14.9268 8.83524 15.4349 8.95 16H10C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4H3ZM14 7C13.7348 7 13.4804 7.10536 13.2929 7.29289C13.1054 7.48043 13 7.73478 13 8V14.05C13.3217 13.9843 13.6533 13.9826 13.9757 14.045C14.2981 14.1074 14.605 14.2328 14.879 14.4139C15.1529 14.5949 15.3885 14.8282 15.5723 15.1004C15.756 15.3725 15.8844 15.6782 15.95 16H17C17.2652 16 17.5196 15.8946 17.7071 15.7071C17.8946 15.5196 18 15.2652 18 15V8C18 7.73478 17.8946 7.48043 17.7071 7.29289C17.5196 7.10536 17.2652 7 17 7H14Z" fill="#D5A230"/>
                    </svg>
                    <span class="card-label">Odometer Reading</span>
                </div>
                <div class="card-text">
                <span class="card-value">{{ kmLimit }} km</span>
                </div>
            </div>

            <div class="wc-card-unique">
                <!-- <i class="material-icons">call</i> -->
                <div class="card-icon-and-class-name">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H5.153C5.38971 2.00011 5.6187 2.08418 5.79924 2.23726C5.97979 2.39034 6.10018 2.6025 6.139 2.836L6.879 7.271C6.91436 7.48222 6.88097 7.69921 6.78376 7.89003C6.68655 8.08085 6.53065 8.23543 6.339 8.331L4.791 9.104C5.34611 10.4797 6.17283 11.7293 7.22178 12.7782C8.27072 13.8272 9.52035 14.6539 10.896 15.209L11.67 13.661C11.7655 13.4695 11.9199 13.3138 12.1106 13.2166C12.3012 13.1194 12.5179 13.0859 12.729 13.121L17.164 13.861C17.3975 13.8998 17.6097 14.0202 17.7627 14.2008C17.9158 14.3813 17.9999 14.6103 18 14.847V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H15C7.82 18 2 12.18 2 5V3Z" fill="#D5A230"/>
                    </svg>
                    <span class="card-label">Customer Mobile</span>
                </div>
                <div class="card-text">
                <span class="card-value">{{userMobile}}</span>
                </div>
            </div>
        </div>

        <!-- Vehicle Registration Number -->
        <!-- <div class="vehicle-reg">
            <div class="vehicle-reg-num">VEHICLE REGISTRATION NUMBER</div>
            <div class="reg-number">{{ getFormattedRegNo(registrationNumber) }}</div>
        </div> -->
        <div class="vehicle-details-container">
            <div class="vehicle-details-container-left-divs" >
                <div class="vd-header">
                    <!-- <img src="assets/icons/eye-icon.svg" class="vd-icon" alt="icon" /> -->
                     <div class="vehicle-details-svg-bg">
                        <!-- <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7C1.274 2.943 5.064 0 9.542 0C14.02 0 17.81 2.943 19.084 7C17.81 11.057 14.02 14 9.542 14C5.064 14 1.274 11.057 0 7ZM13.542 7C13.542 8.06087 13.1206 9.07828 12.3704 9.82843C11.6203 10.5786 10.6029 11 9.542 11C8.48113 11 7.46372 10.5786 6.71357 9.82843C5.96343 9.07828 5.542 8.06087 5.542 7C5.542 5.93913 5.96343 4.92172 6.71357 4.17157C7.46372 3.42143 8.48113 3 9.542 3C10.6029 3 11.6203 3.42143 12.3704 4.17157C13.1206 4.92172 13.542 5.93913 13.542 7Z" fill="black"/>
                        </svg> -->
                        <!-- <mat-icon> directions_car</mat-icon> -->
                        <!-- <img src="../../../../assets/images/car-images/gold-real-car.jpg"> -->
                        <img src="../../../../assets/images/car-images/gold-car.png">
                    </div>

                    <span>Vehicle Details</span>
                </div>

                <div class="vd-row">
                    <div class="vd-label">Make & Model</div>
                    <div class="vd-value">{{ make }} {{ model }}</div>
                </div>

                <div class="vd-row">
                    <div class="vd-label">Year & Variant</div>
                    <div class="vd-value">{{ mfgYear }} {{ variant }}</div>
                </div>

                <div class="vd-row">
                    <div class="vd-label">Fuel Type</div>
                    <div class="vd-value">{{ fuelType }}</div>
                </div>
            </div>
            <!-- Registration Box (already done earlier) -->
            <div class="vehicle-reg">
                <div class="vehicle-reg-num">Registration Number</div>
                <div class="reg-number">{{ getFormattedRegNo(registrationNumber) }}</div>
            </div>

        </div>



        <h2 class="wc-covered-title-unique">Covered Parts</h2>

        <table class="wc-table-unique" *ngIf="warrantyDetails?.orderItems?.length">
        <thead>
            <tr>
            <th>Part Name</th>
            <th>Part Number</th>
            <th>Brand</th>
            <th>Quantity</th>
            <!-- <th>Price</th>
            <th>Discount</th> -->
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of warrantyDetails.orderItems">
            <td>{{ item.partName || 'N/A' }}</td>
            <td style="color: #666666;">{{ item.partNumber || 'N/A' }}</td>
            <td>{{ item.brandName || 'N/A' }}</td>
            <td>{{ item.quantity || 0 }}</td>
            <!-- <td>{{ item.price | currency:'INR' }}</td>
            <td>{{ item.discount | currency:'INR' }}</td> -->
            </tr>
        </tbody>
        </table>

        <p *ngIf="!warrantyDetails?.orderItems?.length">No items found for this order.</p>

    
        <!-- <div class="wc-certified-wrapper-unique">
            <div class="wc-certified-left-unique">
            <div class="verified-user-cion">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.1992 3.666C3.67336 3.6228 7.01377 2.32015 9.6 0C12.1861 2.32059 15.5265 3.62367 19.0008 3.6672C19.1328 4.4472 19.2 5.2512 19.2 6.0684C19.2 12.3384 15.192 17.6724 9.6 19.6488C4.008 17.6712 0 12.3372 0 6.0672C0 5.2488 0.0683999 4.4472 0.1992 3.666ZM14.0484 8.1156C14.267 7.88928 14.3879 7.58615 14.3852 7.27152C14.3825 6.95688 14.2563 6.65591 14.0338 6.43342C13.8113 6.21093 13.5103 6.08472 13.1957 6.08199C12.881 6.07926 12.5779 6.20021 12.3516 6.4188L8.4 10.3704L6.8484 8.8188C6.62208 8.60021 6.31895 8.47926 6.00432 8.48199C5.68968 8.48472 5.38871 8.61093 5.16622 8.83342C4.94373 9.05591 4.81753 9.35688 4.81479 9.67152C4.81206 9.98615 4.93301 10.2893 5.1516 10.5156L7.5516 12.9156C7.77663 13.1406 8.0818 13.2669 8.4 13.2669C8.7182 13.2669 9.02337 13.1406 9.2484 12.9156L14.0484 8.1156Z" fill="black"/>
                </svg>
            </div>
            <div>
                <strong>Certified Genuine Parts</strong>
                <p>Autoverse Verified</p>
            </div>
            </div>
        </div> -->
    </div>

    <!-- <div class="wc-footer-auth-unique">
        <p>Authorized by</p>
        <h3>Autoverse Certified</h3>
    </div> -->

    </div>
    <div class="wc-buttons-unique">
        <!-- <button class="wc-btn-terms-unique">View Terms & Conditions</button> -->
        <!-- <button class="wc-btn-terms-unique"onclick="document.getElementById('tcuModal').classList.add('tcu-show')"> View Terms & Conditions</button> -->
        <button class="wc-btn-terms-unique" (click)="toggleWarrantyUI()">  View Terms & Conditions</button>
        <!-- <button class="wc-btn-download-unique">Download PDF</button> -->
        <button class="wc-btn-download-unique" (click)="downloadSinglePDFWithTwoDivs()">  Download PDF</button>
        <button class="wc-btn-whatsapp-unique" (click)="shareOnWhatsApp()">Share on WhatsApp</button>
    </div>
</div>

<!-- TERMS & CONDITIONS MODAL -->
<div class="tcu-modal-unique"  *ngIf="showWarrantyUI"> 
    <div class="tcu-content-unique" id="termsDiv">
    <div class="tcu-box-unique">
      <!-- Header -->
      <div class="tcu-logo-box-unique">
        <img src="../../../../assets/icons/autoverse-logo.jfif">
      </div>

      <h2 class="tcu-title-unique">Terms & Conditions</h2>

       <ol class="tcu-list-unique">
        <li *ngFor="let term of termsAndConditionList">
          {{ term }}
        </li>
      </ol>

      <p class="tcu-footer-text-unique">
        Autoverse – India’s Trusted Genuine Automotive Parts Platform
      </p>
    </div>
  </div>
      <!-- Close Button -->
     <div class="wc-buttons-unique">
        <!-- <button class="wc-btn-terms-unique">View Terms & Conditions</button> -->
        <!-- <button class="wc-btn-terms-unique"onclick="document.getElementById('tcuModal').classList.add('tcu-show')"> View Terms & Conditions</button> -->
        <button class="wc-btn-terms-unique" (click)="toggleCertificateUI()">  View Certificate</button>
        <button class="wc-btn-download-unique" (click)="downloadSinglePDFWithTwoDivs()">Download PDF</button>
        <button class="wc-btn-whatsapp-unique" (click)="shareTermsOnWhatsApp()">Share on WhatsApp</button>
    </div>
</div>

